import { type ApolloClient } from '@apollo/client';
import { useMutation } from '@apollo/client/react';
import {
	type TrackSearchAddToCartMutation,
	type TrackSearchAddToCartMutationVariables
} from '../../../../client/__generated__/graphql-client-types';
import { TRACK_SEARCH_ADD_TO_CART } from '../../../queries/search/search-tracking.queries';

export type SearchAddToCartParams = {
	searchId: string;
	familyId: number;
	uniqueId: number;
	quantity: number;
};
export type TrackSearchAddToCartAction = (params: SearchAddToCartParams) => Promise<ApolloClient.MutateResult>;

/**
 * TRACK_SEARCH_ADD_TO_CART mutation sends a Signal for an add to cart event for Fusion Search tracking
 * https://doc.lucidworks.com/fusion/5.2/466/signals-types-and-structures
 */
export function useTrackSearchAddToCart() {
	const [trackSearchAddToCartMutation] = useMutation<TrackSearchAddToCartMutation, TrackSearchAddToCartMutationVariables>(
		TRACK_SEARCH_ADD_TO_CART
	);

	const trackSearchAddToCart: TrackSearchAddToCartAction = ({
		searchId,
		familyId,
		uniqueId,
		quantity
	}): Promise<ApolloClient.MutateResult> => {
		return trackSearchAddToCartMutation({ variables: { input: { searchId, familyId, uniqueId, quantity } } });
	};

	return {
		trackSearchAddToCart
	};
}
